// Slow, quiet editorial marquee of the clinic's values.
export default function Marquee({ items, className = "" }) {
  const row = [...items, ...items];
  return (
    <div className={`overflow-hidden ${className}`} aria-hidden="true">
      <div className="marquee-track flex w-max items-center gap-10 whitespace-nowrap">
        {row.map((item, i) => (
          <span key={i} className="flex items-center gap-10">
            <span className="font-serif text-2xl italic text-pine/70 md:text-3xl">
              {item}
            </span>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" className="text-marigold">
              <path d="M12 3c2 4 5 5 9 5-4 0-7 1-9 5-2-4-5-5-9-5 4 0 7-1 9-5z" fill="currentColor" opacity="0.85" />
            </svg>
          </span>
        ))}
      </div>
    </div>
  );
}
